import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { IPartnerRefIDsView } from 'clickNgo/models/crud/views/iPartnerRefIDsView'
import { Logic, Operator } from 'core-components/types'
import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'
import Logger from 'core/utils/Logger'

import { mapOrderManagementItemFromPartnerRefIDs } from './mapping/mapOrderManagementItemFromPartnerRefIDs'

interface IParams {
  partnerId: string
  shouldFetch?: boolean
}

export const fetchPartnerRefIDs = async (
  { partnerId, shouldFetch = false }: IParams,
  options?: ICrudFetchOptions
) => {
  if (!shouldFetch) {
    return []
  }

  const crud = CrudStore.get(
    CrudStoreItem.PartnerRefIDs,
    `PartnerRefIDs:${partnerId}`
  ) as Crud<IPartnerRefIDsView>

  crud.setFilter({
    logic: Logic.AND,
    filters: [
      {
        field: 'PartnerId',
        operator: Operator.EQUAL,
        value: partnerId,
      },
    ],
  })

  return crud
    .fetch({
      force: options?.isForce,
      skipHierarchyFilter: options?.skipHierarchyFilter,
      skipTotal: options?.skipTotal,
    })
    .then((response) => {
      if (response.items.length > 0) {
        return response.items.map(mapOrderManagementItemFromPartnerRefIDs)
      }

      return []
    })
    .catch((e) => {
      Logger.error({ e })
      return []
    })
}
